import React from 'react';
import { ModalButtonSave, ModalButtonUpdate,  } from '../../constant';
import { FormMicSample } from './FormMicSample';
import { Dialog } from 'primereact/dialog';

export const ModalMicSample = (props) => {

    const{
        modal, modalTitle, toggle, method, loading,
        name, handleInputChange,
        validaciones, saveCreate, saveUpdate,
        closeDialog, 

    } = props;

    return (
        <Dialog 
            header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
        >
        
            {
                method === "create"
                ? 
                    <FormMicSample
                        button={ModalButtonSave}
                        {...{ toggle, loading, handleInputChange, validaciones, closeDialog, methodAction: saveCreate }}
                    />
                :
                (method === "update")
                ?
                    <FormMicSample
                        button={ModalButtonUpdate}
                        {...{ toggle, loading, handleInputChange, validaciones, closeDialog, methodAction: saveUpdate, name, }}
                    />
                :
                null
            }
        </Dialog>
    )
}
